import React from 'react';
import SettingsBox from '@medflex/components/stories/SettingsBox';
import Spinner from '@medflex/components/stories/Spinner';
import { useTranslation } from 'react-i18next';
import { SUBSCRIPTION_PLANS } from '@medflex/utils/subscriptionEnums';
import { IconExclamationOutline } from '@medflex/components/stories/Icons';
import Badge, { KINDS } from '@medflex/components/stories/Badge';
import { STATUS } from '../../store/models/subscription';
import useSubscription from '../../hooks/useSubscription';
import { MODALS } from '../../hooks/useIsModal';
import useModal from '../../hooks/useModal';

const PhysicianSubscriptionModule = () => {
  const { t } = useTranslation('physician', { keyPrefix: 'PhysicianSubscriptionModule' });
  const { plan, status, trialEndedAt, upgradeUrl } = useSubscription(true);
  const { open } = useModal();

  const hasUpgradeOptions =
    ![SUBSCRIPTION_PLANS.ENTERPRISE, SUBSCRIPTION_PLANS.PROFESSIONALPLUS].includes(plan) ||
    trialEndedAt;

  return (
    <div
      data-component="PhysicianSubscriptionModule"
      className="flex flex-col flex-1 overflow-y-auto"
    >
      <h1 className="text-2xl font-semibold flex items-center mb-4">
        {t('title')}
        {status === STATUS.LOADING && <Spinner className="ml-2" />}
      </h1>

      {status === STATUS.LOADED && (
        <SettingsBox title={t('subscriptionPlan.title')} className="mb-6">
          <div>
            <div className="text-sm text-slate-500">{t('subscriptionPlan.current')}</div>
            <div className="mb-3">
              {hasUpgradeOptions && !trialEndedAt ? (
                <button
                  type="button"
                  className="focus:outline-none text-slate-800"
                  onClick={() => open({ modal: MODALS.featureUpgrade })}
                >
                  {t(`plans.${plan}`)}
                  <Badge className="ml-2" kind={KINDS.SIGNAL}>
                    {t('upgrade')}
                  </Badge>
                </button>
              ) : (
                <div className="text-slate-800">{t(`plans.${plan}`)}</div>
              )}
            </div>
            {trialEndedAt && hasUpgradeOptions && (
              <div className="flex">
                <IconExclamationOutline className="text-blue-500 mr-3" width="16px" height="16px" />
                <div className="text-sm text-slate-800">
                  {t('subscriptionPlan.trialNote')}
                  <br />
                  <a target="_blank" className="text-blue-500" href={upgradeUrl} rel="noreferrer">
                    {t('subscriptionPlan.upgradeLink')}
                  </a>
                </div>
              </div>
            )}
          </div>
        </SettingsBox>
      )}
    </div>
  );
};

export default PhysicianSubscriptionModule;
